import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader from './AppHeader';
import CuisineSections from './CuisineSections';
import SectionWiseItem from './SectionWiseItem';
import CartToast from './CartToast';
import BottomMenu from './BottomMenu';

const MenuSection = (props) => {
    return (
        props.section.map(post =>
            <div className="item dish" key={post.id}><p className="ds">{post.name}</p></div>
        )
    );
};
  
class Listing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true,
            LOCATION: this.props.location.pathname, 
            id: [],
            SECTION: [],
            MENU: [],
            CLOSED: '',
            OPENS: '',
            ENDS: '',
            displayCartToast: 'N',
            search_text: props.match.params.search_text,
            selectedSECTION: props.match.params.id
        };
    }

    fetchRestaurantMenu(mode,id,type,search_text,selectedSECTION) {
        var that = this;
        fetch('https://www.peepkitchen.in/peep/pwa/api/restaurantmenu_api.php?mode='+mode+'&id='+id+'&type='+type+'&search_text='+search_text+'&selectedSECTION='+selectedSECTION,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            var sections = result.section;
            /*Object.keys(sections).forEach(function(key) {
                //console.log(sections[key].veg);
                if(type=='Y' && sections[key].veg==0)
                    delete sections[key];
            });*/ 

            /*//Clearing the cart if restaurant is closed
            if(result.closed=='Y')
            {
                localStorage.removeItem('cartRES');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
            }*/

            let displayCartToast = 'N';
            let cart = localStorage.getItem('cartData');
            if(cart !== null && cart!=='{}')
                displayCartToast = 'Y';

            that.setState({ LOADING: false, SECTION:sections, MENU:result.menu, CLOSED:result.closed, OPENS:result.opens, ENDS:result.ends, displayCartToast:displayCartToast });
        });
    }

    handleVegOnlyChecked = (e) => {
        //e.preventDefault();
        var restaurant_id = localStorage.getItem('REST');
        var vegONLY = localStorage.getItem('vegONLY') || 'N';
        var vegONLY_new = vegONLY=='Y'?'N':'Y';
        localStorage.setItem('vegONLY', vegONLY_new);
        var search_text = this.state.search_text;
        if(search_text==undefined || search_text=='undefined')
            search_text = '';

        this.fetchRestaurantMenu('MENU',restaurant_id,vegONLY_new,search_text);
    }    

    handleCusineClick = (cuisine_id) => {
        var that = this;
        that.setState({ selectedSECTION:cuisine_id });
    }

    inCartCallBack = () =>{

        let displayCartToast = 'N';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            displayCartToast = 'Y';
        //console.log(cart);
        //console.log(displayCartToast);
        var that = this;
        that.setState({ displayCartToast:displayCartToast });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }

        var restaurant_id = localStorage.getItem('REST');
        var vegONLY = localStorage.getItem('vegONLY') || 'N';
        var search_text = this.state.search_text;
        if(search_text==undefined || search_text=='undefined')
            search_text = '';

        this.fetchRestaurantMenu('MENU',restaurant_id,vegONLY,search_text,this.state.selectedSECTION);
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload()

        //if (nextProps.match.params.search_text !== this.props.match.params.search_text) {
            this.state.loading = true;
            var restaurant_id = localStorage.getItem('REST');
            var vegONLY = localStorage.getItem('vegONLY') || 'N';
            this.state.search_text = nextProps.match.params.search_text

            this.fetchRestaurantMenu('MENU',restaurant_id,vegONLY,this.state.search_text);
        //}
    }
    
    /*componentDidUpdate(prevProps, prevState) {
        console.log('1');
        if (prevState.search_text !== this.state.search_text) {
            this.fetchRestaurantMenu('MENU',restaurant_id,vegONLY,search_text);
        }
    }*/
    
    render() { 

        if(localStorage.getItem('REST')==null)
        {
	        return (<Redirect to={'/map2'}/>)
        }
        
        //localStorage.removeItem("userData");
        //console.log(localStorage.getItem('userData'));

        let AppHeaderClass = 'appHeader bg-primary text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Restaurant';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = this.state.search_text;

        let props = {
            sections: this.state.SECTION,
            items: this.state.MENU,
            selectedSECTION: this.state.selectedSECTION,
            handleVegOnlyChecked: this.handleVegOnlyChecked,
            inCartCallBack: this.inCartCallBack,
            handleCusineClick: this.handleCusineClick,
            CLOSED: this.state.CLOSED,
            OPENS: this.state.OPENS
        };

        return (
            <div>
                {this.state.LOADING && <Loader /> }
                <AppHeader AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />
                <div id="appCapsule">
                    <div className="section full"> 
                        <img src="/assets/img/listing-image.jpg" alt="image" className="imaged square w-100" /> 
                    </div>
                    {this.state.CLOSED!='Y' && this.state.ENDS=='' && <p className="timings">{this.state.OPENS}</p>}
                    {this.state.CLOSED!='Y' && this.state.ENDS!='' && <p className="timings2">{this.state.ENDS}</p>}
                    {this.state.SECTION.length>0 && <CuisineSections {...props} /> }
                    <SectionWiseItem {...props} />
                    <p className="conditions">*Actual dish may differ from the images displayed</p>
                    <br/>
                </div>
                {this.state.CLOSED=='Y' && 
                    <div id="toast-1" class="toast-box toast-top bg-warning show" style={{'padding': '6px', 'minHeight': '22px !important'}}>
                        <div class="in">
                            <div class="text">{this.state.OPENS}</div>
                        </div>
                    </div>
                }
                {this.state.displayCartToast=='Y' && <CartToast items={this.state.MENU} />}
                <BottomMenu LOCATION={this.state.LOCATION} />
            </div>
        );
    }
}
      
export default Listing;


// WEBPACK FOOTER //
// ./src/components/Listing.js